import { Button, Form, Input, InputNumber, Select, Switch } from 'antd';
import { useEffect } from 'react';
import { formItemLayout, tailFormItemLayout } from 'utils/formConfig';

const { TextArea } = Input;

const MarketIndexForm = ({
  form,
  submiting,
  onFinish,
  initialValues = {},
  name,
}) => {
  useEffect(() => {
    form.setFieldsValue(initialValues);
  }, [form, initialValues]);

  return (
    <Form
      {...formItemLayout}
      form={form}
      name={name || 'market_index_form'}
      onFinish={onFinish}
      initialValues={initialValues}
      scrollToFirstError
    >
      <Form.Item
        name="symbol"
        label="Symbol"
        rules={[{ required: true, message: 'Please enter a symbol' }]}
      >
        <Input placeholder="VNINDEX" />
      </Form.Item>
      <Form.Item
        name="name"
        label="Name"
        rules={[{ required: true, message: 'Please enter a name' }]}
      >
        <Input placeholder="VN-Index" />
      </Form.Item>
      <Form.Item name="exchange" label="Exchange">
        <Select allowClear>
          <Select.Option value="HOSE">HOSE</Select.Option>
          <Select.Option value="HNX">HNX</Select.Option>
          <Select.Option value="UPCOM">UPCOM</Select.Option>
        </Select>
      </Form.Item>
      <Form.Item name="description" label="Description">
        <TextArea rows={3} placeholder="What this index represents" />
      </Form.Item>
      <Form.Item
        name="featured"
        label="Featured"
        valuePropName="checked"
        tooltip="Featured indexes are shown first"
      >
        <Switch />
      </Form.Item>
      <Form.Item
        name="ordering"
        label="Ordering"
        tooltip="Lower values are shown first"
      >
        <InputNumber min={0} placeholder="0" style={{ width: '100%' }} />
      </Form.Item>

      <Form.Item {...tailFormItemLayout}>
        <Button type="primary" htmlType="submit" loading={submiting}>
          Save
        </Button>
      </Form.Item>
    </Form>
  );
};

export default MarketIndexForm;
